module.exports = __webpack_public_path__ + "static/media/depressionc742c0fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/depression.svg
// module id = 1324
// module chunks = 0